import React, { useEffect, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { useFeedback } from '@yandex-int/pythia-feedback';

const { REACT_APP_YA_PYTHIA_GUID, REACT_APP_MODE } = process.env;

export const YaFeedback = () => {
  const user = useSelector((store) => store.user);
  const isUserReady =
    user?.id && user?.dealers?.length && user.dealers.length === user.totalDealersNumber;

  return isUserReady ? <FeedbackCore user={user} /> : null;
};

const FeedbackCore = ({ user }) => {
  const isProd = REACT_APP_MODE === 'production';
  const dealerParams = user.dealers.find((el) => el.id === user.dealer) || {};

  const feedbackConfig = useMemo(
    () => ({
      query: {
        'Id user': user.id,
        'Роль': user.role,
        'Id дилера': user.dealer,
        'Наименование дилера': dealerParams.name || '',
        'Регион': dealerParams.timeZone || '',
        'Фамилия': user.lastname,
        'Имя': user.firstname,
        'Отчество': user.middlename,
        'Email': user.email,
      },
      hideHeader: true,
      uid: String(user.id),
      lang: user.locale,
      customParams: {
        roleId: user.role,
        dealerId: user.dealer,
        login: user.email,
        region: dealerParams.timeZone || '',
      },
      testIds: isProd ? null : ['test'],
    }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [user, dealerParams]
  );

  useFeedback(REACT_APP_YA_PYTHIA_GUID, feedbackConfig.query, {
    hideHeader: feedbackConfig.hideHeader,
    uid: feedbackConfig.uid,
    lang: feedbackConfig.lang,
    customParams: feedbackConfig.customParams,
    testIds: feedbackConfig.testIds,
  });

  useEffect(() => {
    if (!window.Ya) return;

    const initFeedback = () => {
      window.Ya.Feedback.App.init(REACT_APP_YA_PYTHIA_GUID, feedbackConfig);
      window.Ya.Feedback.App.fetch();
      window.Ya.Feedback.App.setDefaultQueryParams(feedbackConfig.query);
    };

    if (window.Ya.Feedback?.App) {
      initFeedback();
    } else {
      const listener = () => {
        if (window.Ya.Feedback?.App) {
          initFeedback();
          window.removeEventListener('yandex-feedback-loaded', listener);
        }
      };
      window.addEventListener('yandex-feedback-loaded', listener);
      return () => window.removeEventListener('yandex-feedback-loaded', listener);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user.role, user.dealer]);

  return null;
};
